import { createStore, applyMiddleware, Middleware} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { rootReducer } from './root-reducer';
import thunk, { ThunkDispatch} from 'redux-thunk'
import { ExceptionData } from '../api/models/ExceptionData';
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import { refreshTokenAsyncThunk, logoutAsyncThunk } from '../Auth/actions/AuthActions';
import { showError } from '../Layout/actions/LayoutActions';
import { RootState } from 'typesafe-actions';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { dateTransform } from './redux-persist-transforms'
import createFilter from 'redux-persist-transform-filter';
import { ThunkAction, Action, AnyAction } from '@reduxjs/toolkit';

export const browserHistory = createBrowserHistory()

const exceptionMid: Middleware = api => next => action => {
    if (action.type.endsWith("_ERROR")) {
        if ((action.payload as ExceptionData).code === 401) {
            (store.dispatch as ThunkDispatch<any, any, AnyAction>)(logoutAsyncThunk())
        } else {
            api.dispatch(showError((action.payload as ExceptionData).message))
        }
    }

    if (action.type.endsWith("_REQUEST")) {
        if ((api.getState() as RootState).authRdc.lastRefresh && new Date().getTime() - (api.getState() as RootState).authRdc.lastRefresh.getTime() > 15 * 60 * 1000) //refresh after 30minutes
        {
            (store.dispatch as ThunkDispatch<any, any, AnyAction>)(refreshTokenAsyncThunk()).then(() => console.log("Token refreshed")).finally(() => { return next(action) })
        }
        else return next(action);
    }
    else
        return next(action);
}

const persistFilter = createFilter('orderSheetsRdc',['currentOrderSheet', 'orderSheets'])

const persistConfig = {
    key: 'root',
    storage,
    transforms: [persistFilter, dateTransform],
    whitelist: [] //'orderSheetsRdc'
}

const persistedReducer = persistReducer(persistConfig, rootReducer(browserHistory))
const middleware = applyMiddleware(thunk, routerMiddleware(browserHistory), exceptionMid)

// create store
const store = createStore(persistedReducer, composeWithDevTools(middleware));
export type RootState2 = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
ReturnType,
RootState2,
unknown,
Action<string>
>;

export const persistor = persistStore(store)

// export store singleton instance
export default store;
